import {BaseData} from '../base/static_config_data/BaseData';
import {ActiveData} from '../../ActiveData';
import {CardStackDataEvent} from './card_stack_data/CardStackDataEvent';
import {ArrayWrap} from '../base/static_config_data/ArrayWrap';
import {StringData} from '../base/static_config_data/StringData';
import {CardData, ICardData} from './card_stack_data/CardData';
import {StaticData} from '../../StaticData';

export class CardStackData extends BaseData
{
    tags!: ArrayWrap<StringData, string>;
    cards!: ArrayWrap<CardData, ICardData>;
    flippedFor!: ArrayWrap<StringData, string>;
    hiddenFor!: ArrayWrap<StringData, string>;
    invisibleFor!: ArrayWrap<StringData, string>;
    visibleFor!: ArrayWrap<StringData, string>;

    constructor(public config: ICardStackData | null = null) {
        super();

        if (!this.config) {
            return;
        }

        if (!this.config.cards) {
            //debugger;
        }

        this.tags = new ArrayWrap<StringData, string>(StringData, this.config.tags || []);
        this.cards = new ArrayWrap<CardData, ICardData>(CardData, this.config.cards || []);

        this.flippedFor = new ArrayWrap<StringData, string>(StringData, this.config.flippedFor || []);
        this.hiddenFor = new ArrayWrap<StringData, string>(StringData, this.config.hiddenFor || []);
        this.invisibleFor = new ArrayWrap<StringData, string>(StringData, this.config.invisibleFor || []);
        this.visibleFor = new ArrayWrap<StringData, string>(StringData, this.config.visibleFor || []);
    }

    get angle(): number {
        return this.config!.angle;
    }

    set angle(value: number) {
        this.config!.angle = value;
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.ANGLE_CHANGED, this.config!.angle);
    }

    get blockedByPlayer(): string {
        return this.config!.blockedByPlayer;
    }

    set blockedByPlayer(value: string) {
        if (this.config!.blockedByPlayer == value) {
            return;
        }
        this.config!.blockedByPlayer = value;
        ActiveData.addEventToPool<string>(this, CardStackDataEvent.BLOCKED_BY_PLAYER_CHANGED, this.config!.blockedByPlayer);
    }

    get title(): string {
        return this.config!.title;
    }

    set title(value: string) {
        this.config!.title = value;
        ActiveData.addEventToPool<string>(this, CardStackDataEvent.TITLE_CHANGED, this.config!.title);
    }

    get id(): number {
        return this.config!.id;
    }

    set id(value: number) {
        this.config!.id = value;
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.ID_CHANGED, this.config!.id);
    }

    get locked(): boolean {
        return this.config!.locked;
    }

    set locked(value: boolean) {
        this.config!.locked = value;
        ActiveData.addEventToPool<boolean>(this, CardStackDataEvent.LOCKED_CHANGED, this.config!.locked);
    }

    get masterLocked(): boolean {
        return this.config!.masterLocked;
    }

    set masterLocked(value: boolean) {
        this.config!.masterLocked = value;
        ActiveData.addEventToPool<boolean>(this, CardStackDataEvent.MASTER_LOCKED_CHANGED, this.config!.masterLocked);
    }

    get onTable(): boolean {
        return StaticData.isAdmin ? this.config!.onTable! : true;
    }

    set onTable(value: boolean) {
        this.config!.onTable = value;
        ActiveData.addEventToPool<boolean>(this, CardStackDataEvent.ON_TABLE_CHANGED, this.config!.onTable);
    }

    get usedByPlayer(): string {
        return this.config!.usedByPlayer;
    }

    set usedByPlayer(value: string) {
        if (this.config!.usedByPlayer == value) {
            return;
        }
        this.config!.usedByPlayer = value;
        ActiveData.addEventToPool<string>(this, CardStackDataEvent.USED_BY_PLAYER_CHANGED, this.config!.usedByPlayer);
        if (value == '') {
            this.blockedByPlayer = '';
        }
    }

    get width(): number {
        return this.config!.width;
    }

    set width(value: number) {
        this.config!.width = value;
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.WIDTH_CHANGED, this.config!.width);
    }

    get height(): number {
        return this.config!.height;
    }

    set height(value: number) {
        this.config!.height = value;
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.HEIGHT_CHANGED, this.config!.height);
    }

    get x(): number {
        return this.config!.x;
    }

    set x(value: number) {
        this.config!.x = value;
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.X_CHANGED, this.config!.x);
    }

    get y(): number {
        return this.config!.y;
    }

    set y(value: number) {
        this.config!.y = value;
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.Y_CHANGED, this.config!.y);
    }

    get z(): number {
        return this.config!.z;
    }

    set z(value: number) {
        this.config!.z = value;
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.Z_CHANGED, this.config!.z);
    }

    flip() {
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.FLIPPED);
    }

    shuffle() {
        ActiveData.addEventToPool<number>(this, CardStackDataEvent.SHUFFLED);
    }
}

export interface ICardStackData
{
    angle: number;
    blockedByPlayer: string;
    cards: ICardData[];
    flippedFor: string[];
    hiddenFor: string[];
    invisibleFor: string[];
    visibleFor: string[];
    id: number;
    locked: boolean;
    masterLocked: boolean;
    tags: [];
    title: string;
    usedByPlayer: string;
    width: number;
    height: number;
    x: number;
    y: number;
    z: number;
    onTable?: boolean;
}
